import React from 'react';

/**
 * Single-choice question renderer (radio buttons).
 * Large clickable areas for the entire row.
 */
export default function SingleChoice({ question, answer, onChange, disabled = false }) {
  return (
    <div className="space-y-2">
      {question.options.map(option => (
        <label
          key={option.id}
          className={`flex items-start gap-3 p-4 rounded-lg border-2 cursor-pointer transition-all ${
            disabled ? 'cursor-default' : 'hover:bg-gray-50'
          } ${
            answer === option.id
              ? 'border-blue-500 bg-blue-50'
              : 'border-gray-200 bg-white'
          }`}
        >
          <input
            type="radio"
            name={`q-${question.id}`}
            value={option.id}
            checked={answer === option.id}
            onChange={() => !disabled && onChange(option.id)}
            disabled={disabled}
            className="mt-1 shrink-0"
          />
          <div>
            <span className="font-medium text-gray-400 mr-2">{option.id}.</span>
            <span className="text-gray-900">{option.text}</span>
          </div>
        </label>
      ))}
    </div>
  );
}
